module.exports = __webpack_public_path__ + "static/media/nopallet.5293af5e.jpg";